import { useState } from 'react';
import { getCarReportPreview } from '../../services/reportService';

const useGetCarReportPreview = (vin) => {
  const [reportPreview, setReportPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCarReportPreview = async () => {
    setLoading(true);
    try {
      const response = await getCarReportPreview(vin);
      if (response) {
        setReportPreview(response.data);
        setError(null);
      } else {
        setError('No preview available');
      }
    } catch (err) {
      // console.log('Error fetching car report', err);
      if (err.response) {
        setError(`${err.response.data.message}`);
      } else if (err.request) {
        setError('Error: No response from server');
      } else {
        setError(`Error: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return { reportPreview, loading, error, fetchCarReportPreview };
};

export default useGetCarReportPreview;